import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/index.css';
import RouterIndex from './Route';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<RouterIndex />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js